import { action, makeObservable, observable } from "mobx";

import type { BackendSessionState } from "../../app/core/lib/auth/backends";
import { IHRLoginOptions, SessionBackend, BaseStoreSession } from "@ihr-radioedit/inferno-core";

/** Add new members to Base */
export class StoreSession<T = BackendSessionState> extends BaseStoreSession<T> {
  @observable
  currentSession: SessionBackend<T, IHRLoginOptions> | null = null;

  constructor(currentSession: SessionBackend<T, IHRLoginOptions> | null) {
    super();
    makeObservable(this);
    this.currentSession = currentSession;
  }

  @action
  storeSession = (session: any) => {
    this.currentSession = session;
  };
}
